import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TileKeyValueIndicatorComponent } from './tile-key-value-indicator.component';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [TileKeyValueIndicatorComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatTooltipModule
  ],
  exports: [TileKeyValueIndicatorComponent]
})
export class TileKeyValueIndicatorModule { }
